import {httpService, httpGatewayService} from "@/modules/common/services";
import {getQuery, postQuery, putQuery} from "@/modules/common/utils";

const CONTACT_PATH = 'business/clients/v1/contacts';
const CLIENTS_PATH = 'clients';
const PAYMENTS_PATH = 'business/payments/v1';
const CLIENT_SETTINGS_PATH = 'v3/business/client_settings';

const getClient = async (uid) => {
  const res = await httpService.get(`${CLIENTS_PATH}/${uid}`, {full: true});

  if (res.error) {
    return {error: res.error};
  } else {
    return {client: res};
  }
};

const getContact = uid => getQuery(`${CONTACT_PATH}/${uid}`, {new_api: true});
const getMattersForContact = uid => getQuery(`${CONTACT_PATH}/${uid}/matters`, {new_api: true});
const getClientSettings = (uid) => {
  return httpGatewayService.get(`${CLIENT_SETTINGS_PATH}/${uid}`, {api_gw: true});
};
const getOrigContact = uid => getQuery(`${CONTACT_PATH}/${uid}`, {new_api: true});

const validatePhone = (phone) => getQuery(`${CLIENTS_PATH}/validate_phone`, {phone});
const validateEmail = (email) => getQuery(`${CLIENTS_PATH}/validate_email`, {email});
const updateContact = (contactUid, data) => putQuery(`${CLIENTS_PATH}/${contactUid}`, data);
const sendCardRequest = (data) => {
  data.new_api = true
  return postQuery(`${PAYMENTS_PATH}/card_requests`, data);
}

export default {
  getClient,
  getContact,
  getMattersForContact,
  getClientSettings,
  getOrigContact,
  validatePhone,
  validateEmail,
  updateContact,
  sendCardRequest,
}
